export interface PromoSlide {
  id: string;
  image: string;
  name: string;
  category: string;
  description: string;
  logo: string;
  rating: number;
  reviews: number;
  website: string;
  phone: string;
  ctaText?: string;
}

export const promoSlides: PromoSlide[] = [
  {
    id: "hero-1",
    image: "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?auto=format&fit=crop&w=2000&q=80",
    name: "Habesha Tax & Insurance",
    category: "Trusted Financial Services",
    description:
      "Tax preparation, strategy & consultancy plus car, home, life, and health insurance—all in one trusted place. Call now: 214-799-7017.",
    logo: "https://habeshaservice.com/lovable-uploads/f7dbc8cf-9c0c-42ec-8ef0-a81174809496.jpeg",
    website: "https://www.habeshaservice.com",
    phone: "tel:+12147997017",
    ctaText: 'Get a Free Consultation',
    rating: 5.0,
    reviews: 124
  },
  {
    id: "hero-2",
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=2000&q=80",
    name: "Feature Your Business",
    category: "Advertisement",
    description:
      "Showcase your products or services with premium placement designed to boost visibility and conversions.",
    logo: "https://dummyimage.com/200x200/1e293b/ffffff&text=Brand",
    website: "/about/#contact",
    phone: "/about/#contact",
    rating: 5.0,
    reviews: 0
  },
  {
    id: "hero-3",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=2000&q=80",
    name: "Launch a Campaign",
    category: "Sponsored Slot",
    description:
      "A powerful promotional space for brands looking to make an impact and drive meaningful engagement.",
    logo: "https://dummyimage.com/200x200/020617/ffffff&text=Ad",
    website: "/about/#contact",
    phone: "/about/#contact",
    rating: 5.0,
    reviews: 0
  },
  {
    id: "hero-4",
    image: "https://images.unsplash.com/photo-1556740758-90de374c12ad?auto=format&fit=crop&w=2000&q=80",
    name: "Premium Ad Placement",
    category: "Featured Advertisement",
    description:
      "Stand out with a visually rich promotion placed where users are most likely to engage.",
    logo: "https://dummyimage.com/200x200/111827/ffffff&text=Logo",
    website: "/about/#contact",
    phone: "/about/#contact",
    rating: 5.0,
    reviews: 0
  },
  {
    id: "hero-5",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=2000&q=80",
    name: "Advertise With Confidence",
    category: "Sponsored",
    description:
      "This space is optimized for brand storytelling, visibility, and measurable results.",
    logo: "https://dummyimage.com/200x200/030712/ffffff&text=Brand",
    website: "/about/#contact",
    phone: "/about/#contact",
    rating: 5.0,
    reviews: 0
  }
];
